import { NetworkApi } from 'network';
import { List } from 'types/List';
import {
	PaymentReceipt,
	PaymentReceiptFile,
	PaymentReceiptsFilters,
} from '../pages/PaymentReceipts/types';

export class PaymentReceiptsService extends NetworkApi {
	public static getPaymentReceipts(filters?: PaymentReceiptsFilters) {
		return this.get<List<PaymentReceipt>, PaymentReceiptsFilters>(
			'/payment-receipts',
			filters,
		);
	}

	public static getPaymentReceiptFile(postingId: string) {
		return this.get<PaymentReceiptFile>(`/payment-receipts/${postingId}`);
	}
}
